export default date => /^20[0-9][0-9]-[0-9]{2}-[0-9]{2}$/.test(date); // TODO
